import graphql from 'babel-plugin-relay/macro';

export const CreateOrUpdateFcmDevice = graphql`
mutation CreateOrUpdateFcmDeviceMutation($input: CreateOrUpdateFCMDeviceInput!) {
    createOrUpdateFcmDevice(input: $input) {
        fcmDevice {
            id
        }
    }
}
`;
